import './App.css';
import React from 'react';
import Navbar from './components/Navbar';
import Textform from './components/Textform';
import About from './components/About'
import { useState } from 'react';
import Alert from './components/Alert';
import Footer from './components/Footer';
import {
  HashRouter as Router,
  Route,
  Routes,
} from "react-router-dom";

function App() {
  const [mode,setMode]=useState('light');
  const [alert,setAlert]=useState(null);
  const showAlert=(message,type)=>{
    setAlert({
      message:message,
      type:type
    })
    setTimeout(()=>{
      setAlert(null);
    },1500)
  }
  const [myStyle,setMyStyle]=useState({
    color:'black',
    backgroundColor:'white'
  });
  
    const forDark=()=>{
      if(myStyle.backgroundColor==='white'){
        setMyStyle({
          color:'white',
          backgroundColor:'#030e12',
        })
        showAlert("Dark Mode has been Enabled","success");
        setMode('dark');
        
        document.body.style.backgroundColor='#262a30fc';
      }
      else{
        setMyStyle({
          color:'black',
          backgroundColor:'white',
        })
        showAlert("Light Mode has been Enabled","success");
        setMode('light');
        document.body.style.backgroundColor ='white';
       
      }
    }
  return ( 
    <Router>
    <div className="App">
      {/* <Navbar title="TextChangers"/> */}
      <Navbar title={"TextChanger"}   toggleMode={forDark} myStyle={myStyle}/>
      <Alert alert={alert} showAlert={showAlert}/>
      <Routes>
        <Route exact path="/about" element={<About mode={mode} myStyle={myStyle}/> }/>
        <Route exact path="/"   element={<Textform myStyle={myStyle} mode={mode} showAlert={showAlert}/>}/>
      </Routes>
      
    <Footer mode={mode} myStyle={myStyle}/>    
    </div>
    </Router>
  );
}

export default App;
